import { cs, type MessageKey } from "./messages/cs.js";
import { en } from "./messages/en.js";
import { typeset } from "./typography.js";

/** Jazyky rozhraní. Jazyk je v URL (`/cs/`, `/en/`, DEC-001). */
export const LOCALES = ["cs", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

export const messages: Record<Locale, Record<MessageKey, string>> = { cs, en };

const rendered = new Map<Locale, Record<MessageKey, string>>();

/** Texty rozhraní k vykreslení: česká typografie na každé zprávě (DES-003 §9). */
export function renderedMessages(locale: Locale): Record<MessageKey, string> {
  let out = rendered.get(locale);
  if (out === undefined) {
    out = Object.fromEntries(Object.entries(messages[locale]).map(([k, v]) => [k, typeset(v, locale)])) as Record<MessageKey, string>;
    rendered.set(locale, out);
  }
  return out;
}

export type { MessageKey };
export { capitalize, typeset } from "./typography.js";
export { captionSentence, listOf, summarySentence } from "./summary.js";
export { adjectiveKey, nounKey, typeNameText, type TextMap, type TextValue } from "./methodology.js";
